// const qqArr = []
// const telegramArr = ['yiyiyiads', 'Meng0115', 'btreemint']
export const openRandomLink = () => {
    window.open('https://contact.bravotree.org', '_blank'); // 在新标签页中打开

  // let links = [];
  // console.log('type', type)
  // // 根据 type 获取对应的链接数组
  // if (type === 1) {
  //   links = telegramArr;
  // } else if (type === 2) {
  //   links = qqArr;
  // } else {
  //   console.error('Invalid type! Please pass 1 for Telegram or 2 for QQ.');
  //   return;
  // }
  // // 随机选择一个链接
  // const randomIndex = Math.floor(Math.random() * links.length);
  // const randomLink = links[randomIndex];

  // // 使用 window.open 跳转到随机选择的链接
  // if (randomLink) {
  //   if (type === 1) {
  //     window.open(`https://t.me/${randomLink}`, '_blank')
  //   } else {
  //     window.open(
  //       `tencent://message/?uin=${randomLink}&Site=qq&Menu=yes`,
  //       '_blank',
  //     )
  //   }
  //   window.open(randomLink, '_blank'); // 在新标签页中打开
  // } else {
  //   console.error('No links available for the selected type.');
  // }
}